<template>
  <ForgotPassword />
</template>

<script>
import ForgotPassword from '../components/templates/ForgotPassword'

export default {
  components: {
    ForgotPassword
  }
}
</script>
